// extracted by mini-css-extract-plugin
export default {"TotalOrLoggedHours":"styles_TotalOrLoggedHours__LAMA0","title":"styles_title__padOW","content":"styles_content__HWmfc"};